import React, { FC } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";

const KeieiShindanManagerAnalysisNgButton: FC<{
  id: string;
  bigItemId: string;
  smallItemId: string;
}> = ({ id, bigItemId, smallItemId }) => {
  return (
    <IconButton>
      <CloseIcon style={{ fontSize: "16px" }} />
    </IconButton>
  );
};
export default KeieiShindanManagerAnalysisNgButton;
